export interface IWebsiteInstallationForm {
  websiteType: string;
  multisiteType: string;
  websiteTitle: string;
  region: string;
  subdomain: string;
  domain: string;
  userName: string;
  password: string;
}

export interface IWebsiteInstallData {
  multisiteType: 'subfolder' | 'subdomain';
  siteTitle: string;
  region: string;
  domain_name: string;
  subdomain: string;
  admin_username: string;
  adminPassword: string;
}

export class WebsiteInstallData implements IWebsiteInstallData {

  multisiteType: 'subfolder' | 'subdomain';
  siteTitle: string;
  region: string;
  domain_name: string;
  subdomain: string;
  admin_username: string;
  adminPassword: string;

  constructor(websiteData: IWebsiteInstallationForm) {
    this.siteTitle = websiteData.websiteTitle;
    this.region = websiteData.region;
    this.subdomain = websiteData.subdomain;
    this.admin_username = websiteData.userName;
    this.adminPassword = websiteData.password;
    websiteData.domain && (this.domain_name = websiteData.domain);
    websiteData.multisiteType && (this.multisiteType = websiteData.multisiteType === 'subdirectory' ? 'subfolder' : 'subdomain');
  }
}
